/* tslint:disable */
/* eslint-disable */
/**
 * RakuLogi API
 * RakuLogi の API ドキュメント
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RequestRegistAmazonItemsRequest } from './RequestRegistAmazonItemsRequest';
import {
    RequestRegistAmazonItemsRequestFromJSON,
    RequestRegistAmazonItemsRequestFromJSONTyped,
    RequestRegistAmazonItemsRequestToJSON,
    RequestRegistAmazonItemsRequestToJSONTyped,
} from './RequestRegistAmazonItemsRequest';

/**
 * 
 * @export
 * @interface RequestBulkRegisterAmazonItemsRequest
 */
export interface RequestBulkRegisterAmazonItemsRequest {
    /**
     * 
     * @type {Array<RequestRegistAmazonItemsRequest>}
     * @memberof RequestBulkRegisterAmazonItemsRequest
     */
    items: Array<RequestRegistAmazonItemsRequest>;
}

/**
 * Check if a given object implements the RequestBulkRegisterAmazonItemsRequest interface.
 */
export function instanceOfRequestBulkRegisterAmazonItemsRequest(value: object): value is RequestBulkRegisterAmazonItemsRequest {
    if (!('items' in value) || value['items'] === undefined) return false;
    return true;
}

export function RequestBulkRegisterAmazonItemsRequestFromJSON(json: any): RequestBulkRegisterAmazonItemsRequest {
    return RequestBulkRegisterAmazonItemsRequestFromJSONTyped(json, false);
}

export function RequestBulkRegisterAmazonItemsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): RequestBulkRegisterAmazonItemsRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'items': ((json['items'] as Array<any>).map(RequestRegistAmazonItemsRequestFromJSON)),
    };
}

export function RequestBulkRegisterAmazonItemsRequestToJSON(json: any): RequestBulkRegisterAmazonItemsRequest {
    return RequestBulkRegisterAmazonItemsRequestToJSONTyped(json, false);
}

export function RequestBulkRegisterAmazonItemsRequestToJSONTyped(value?: RequestBulkRegisterAmazonItemsRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'items': ((value['items'] as Array<any>).map(RequestRegistAmazonItemsRequestToJSON)),
    };
}

